<script lang="ts">
	import PageGrid16 from '../components/pageGrid16.svelte';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';
	import type { ISbStoryData } from '@storyblok/js';

	interface Props {
		content: ISbStoryData<{
			hide_indices: boolean;
			headline: string;
			subheadline: string;
			steps: ISbStoryData[];
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<section use:editable={content} class="my-4 text-brown-1">
	<PageGrid16 margin>
		{#if content.headline}
			<div
				class="col-span-full mb-8 text-balance text-center lg:col-start-4 lg:col-end-[14] lg:mb-12"
			>
				<h1 class="text-[36px]/[112%] tracking-[-.36px] lg:text-[48px]/[120%] lg:tracking-[-.48px]">
					{content.headline}
				</h1>
				{#if content.subheadline}
					<h1
						class="mt-3 text-[16px]/[150%] tracking-[-.16px] text-brown-4 lg:text-[20px]/[140%] lg:tracking-[-.2px]"
					>
						{content.subheadline}
					</h1>
				{/if}
			</div>
		{/if}
		<div class="col-span-full flex flex-col gap-y-8 lg:flex-row lg:gap-x-6">
			{#each content.steps as step, index}
				<Blok
					content={step}
					index={content.hide_indices ? undefined : index}
					size={content.steps.length === 2
						? 'large'
						: content.steps.length === 4
							? 'small'
							: 'regular'}
				/>
			{/each}
		</div>
	</PageGrid16>
</section>
